import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, onMounted, provide } from 'vue';
import { useRoute, useRouter } from 'vue-router/composables';
import { notify } from '@/modules/common/helpers/notification';
import { NotificationTypes } from '@/modules/common/services/http/notification';

import {
  NavBar,
  LoaderIndicator,
  HelperViewStatus
} from '@warrenbrasil/nebraska-web';
import { BackButton } from '@/modules/common/components/buttons';
import { FadeTransition } from '@/modules/common/components/FadeTransition';

import {
  getInvestmentDetails,
  createInvestment,
  IInvestmentDetails
} from '@/modules/transaction/services/variable-income';

import {
  VariableIncomeInvestmentComponents,
  EVariableIncomeInvestmentSteps
} from './helpers';


export default /*#__PURE__*/_defineComponent({
  __name: 'VariableIncomeInvestment',
  setup(__props) {

const route = useRoute();
const router = useRouter();

const currentStep = ref(EVariableIncomeInvestmentSteps.INVESTMENT);
const investmentDetails = ref<IInvestmentDetails>();
const amountFormatted = ref('');
const amountValue = ref(0);

const isLoading = ref(true);
const hasError = ref(false);
const isFetchingInvestment = ref(false);

const portfolioId = computed(() => {
  return route.params.id as string;
});

const step = computed(() => {
  return {
    component: VariableIncomeInvestmentComponents[currentStep.value]
  };
});

const showNavbar = computed(() => {
  return currentStep.value !== EVariableIncomeInvestmentSteps.CONCLUSION;
});

function backStep() {
  if (currentStep.value === EVariableIncomeInvestmentSteps.INVESTMENT) {
    router.push({
      name: 'wealthIndexPortfolio',
      params: { portfolioId: portfolioId.value }
    });

    return;
  }

  currentStep.value = currentStep.value - 1;
}

function changeAmountValue(value: number, formatted: string) {
  amountValue.value = value;
  amountFormatted.value = formatted;

  currentStep.value = EVariableIncomeInvestmentSteps.PREVIEW;
}

async function fetchInvestmentDetails() {
  try {
    isLoading.value = true;
    hasError.value = false;

    investmentDetails.value = await getInvestmentDetails(portfolioId.value);
  } catch {
    hasError.value = true;
  } finally {
    isLoading.value = false;
  }
}

async function fetchInvestment() {
  try {
    isFetchingInvestment.value = true;

    await createInvestment(portfolioId.value, amountValue.value);

    currentStep.value = EVariableIncomeInvestmentSteps.CONCLUSION;
  } catch {
    notify({
      group: 'wrn-notifications',
      text: 'Não foi possível investir nesta carteira. Aguarde alguns instantes e tente novamente.',
      type: NotificationTypes.error
    });
  } finally {
    isFetchingInvestment.value = false;
  }
}

onMounted(() => {
  fetchInvestmentDetails();
});

provide('investmentDetails', investmentDetails);
provide('isFetchingInvestment', isFetchingInvestment);
provide('amountFormatted', amountFormatted);
provide('portfolioId', portfolioId);

provide('fetchInvestment', fetchInvestment);
provide('changeAmountValue', changeAmountValue);

return { __sfc: true,route, router, currentStep, investmentDetails, amountFormatted, amountValue, isLoading, hasError, isFetchingInvestment, portfolioId, step, showNavbar, backStep, changeAmountValue, fetchInvestmentDetails, fetchInvestment, NavBar, LoaderIndicator, HelperViewStatus, BackButton, FadeTransition }
}

})